import {inject, Injectable, InjectionToken} from '@angular/core';
import {Translation, TranslocoLoader} from '@jsverse/transloco';
import {HttpBackend, HttpRequest} from '@angular/common/http';
import {map, Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpBackend);
  private config = inject(TRANSLOCO_LOADER_CONFIG);

  getTranslation(lang: string): Observable<Translation> {
    const req = new HttpRequest('GET', `/assets/i18n/${lang}.json?v=${this.config.version}`);
    return this.http.handle(req).pipe(map((response: any) => response.body!));
  }
}

export interface TranslocoLoaderConfig {
  version?: string;
}

export const TRANSLOCO_LOADER_CONFIG = new InjectionToken<TranslocoLoaderConfig>(
  'TRANSLOCO_LOADER_CONFIG'
);
